$('[data-smooth-scroll]').each((i, element) => {
  $(element).on('click', (ev) => {
    ev.preventDefault();
    const dest = $(element).attr('href');
    console.log(dest);
    $(dest)[0].scrollIntoView({ behavior: 'smooth' });
  });
});
